import { createFileRoute } from "@tanstack/react-router";
import CookiesPolicy from "@/pages/legal/CookiesPolicy";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const breadcrumbSchema = buildBreadcrumb([{ name: "Política de cookies", path: "/legal/cookies" }]);

export const Route = createFileRoute("/legal/cookies")({
  head: () => ({
    meta: [
      { title: "Política de Cookies | SEOEVOLUTION" },
      { name: "description", content: "Política de cookies de SEOEVOLUTION" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/legal/cookies" },
      { property: "og:title", content: "Política de Cookies | SEOEVOLUTION" },
      { property: "og:description", content: "Política de cookies de SEOEVOLUTION" },
      { name: "twitter:title", content: "Política de Cookies | SEOEVOLUTION" },
      { name: "twitter:description", content: "Política de cookies de SEOEVOLUTION" },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/legal/cookies" }],
    scripts: [ldJson(breadcrumbSchema)],
  }),
  component: CookiesPolicy,
});
